import { useTranslation } from 'react-i18next'
import { useNavigate, useOutletContext } from 'react-router'

import { ConnectionSetupRoutes } from 'app/application/types'
import { ConnectionIcon } from 'app/common/presentation'
import { CheckIcon, InnkeeprIcon } from 'app/common/presentation/icons'

import { Button } from 'components'

import styles from '../Connect.module.scss'
import { StepContext } from './StepWithConnectionAndAccounts'
import { ConnectionStepper } from './components/ConnectionStepper/ConnectionStepper'

const ConnectionVerified = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('connections')
  const { accounts, connection } = useOutletContext<StepContext>()

  return (
    <>
      <ConnectionStepper activeStep={3} />
      <section className={styles.connectionVerifiedCard}>
        <header>
          <h2>{t('setup.connectionVerified.card.title')}</h2>
          <p>{t('setup.connectionVerified.card.description')}</p>
        </header>
        <div className={styles.verificationContent}>
          <div className={styles.platforms}>
            <div className={styles.platformIcon}>
              <InnkeeprIcon />
            </div>
            <div className={styles.connectionLine} />
            <div className={styles.platformIcon}>
              <ConnectionIcon connection={connection} />
            </div>
            <div className={styles.connectionVerifiedIcon}>
              <CheckIcon />
            </div>
          </div>
          <div className={styles.verificationStatus}>
            <CheckIcon />
            <span>{t('setup.connectionVerified.status')}</span>
          </div>
          <p className={styles.verificationMessage}>{t('setup.connectionVerified.description')}</p>
        </div>
      </section>
      <div className={styles.actions}>
        <Button onClick={() => void navigate(-1)} variant="secondary">
          {t('setup.actions.back')}
        </Button>
        <Button
          onClick={(event) => {
            event.stopPropagation()
            void navigate(`../${ConnectionSetupRoutes.Settings}`, {
              state: { accounts, connection },
            })
          }}
        >
          {t('setup.signIn.continue')}
        </Button>
      </div>
    </>
  )
}

export default ConnectionVerified
